<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-4 text-center">
        <v-col cols="12">
          <v-img
            :src="require('../assets/' + $t('$assets.logo'))"
            class="my-3"
            contain
            height="200"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Chanjet from "@/api/chanjet";

export default {
  name: "chanjetOAuth",

  mounted() {
    this.$store.dispatch("fullscreenLoading");
    Chanjet.bindChanjet({
      code: this.$route.query.code,
      state: this.$route.query.state,
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.$snackbar.success(i18n.t("Oauth.bindedMsg"));
          if (this.$route.query.state.startsWith("basedata_"))
            this.$router.push("/");
          else if (this.$route.query.state.startsWith("subaccount_"))
            this.$router.push("/settings/sub-account-settings/sub-account");
          else if (this.$route.query.state.startsWith("supplier_"))
            this.$router.push("/supplier");
        }
        this.$store.dispatch("fullscreenLoadingStop");
      }.bind(this)
    );
  },
};
</script>
